import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Team } from "@app/models/rest/team";

@Injectable({
  providedIn: "root"
})
export class TeamRestService extends HateoasResourceOperation<Team> {
  constructor() {
    super(Team);
  }
}
